import { CSSProperties } from 'react';

import UIConfig from '@/UIConfig.ts';

export const headerContainer: CSSProperties = {
  position: 'sticky',
  top: 100,
  left: 0,
  right: 0,
  padding: '6px 0',
  background: UIConfig.Chat.shared.backgroundColor,
  color: 'black',
  zIndex: 3,
  transition: 'opacity 0.3s ease-in-out, visibility 0.3s ease-in-out',
  opacity: 1,
  visibility: 'visible'
};

export const headerContent: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 16px'
};

export const avatarContainer: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  marginLeft: 'auto',
  paddingRight: '10px'
};

export const avatarImage: CSSProperties = {
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  objectFit: 'cover'
};

export const nameContainer: CSSProperties = {
  flex: 1,
  fontWeight: 500,
  fontSize: '16px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
};

export const menuContainer: CSSProperties = {
  display: 'flex',
  justifyContent: 'flex-end',
  width: '40px',
  alignItems: 'center'
};

const indicationStyle: CSSProperties = {
  width: '7px',
  height: '7px',
  borderRadius: '8px',
  display: 'inline-block',
  marginLeft: '6px',
  verticalAlign: 'middle',
  lineHeight: 'normal',
  marginTop: '2px'
};

export const activeIndicatorStyle: CSSProperties = {
  background: '#07B9B6',
  ...indicationStyle
};

export const seenRecentlyIndicatorStyle: CSSProperties = {
  background: '#ff8000',
  ...indicationStyle
};